import type { Permission } from "@octopusdeploy/octopus-server-client";
import { client, session } from "~/clientInstance";

export function hasPermissionsInAnyScope(spaceId: string, permission: Permission) {
    return session.currentPermissions?.scopeToSpace(client.spaceId).hasPermissionInAnyScope(permission) ?? false;
}
